/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} You_Got_New_InviteInputs */

const en_you_got_new_invite = /** @type {(inputs: You_Got_New_InviteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You got an invitation to join!`)
};

const nl_you_got_new_invite = /** @type {(inputs: You_Got_New_InviteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je hebt een uitnodiging ontvangen om lid te worden van`)
};

/**
* | output |
* | --- |
* | "You got an invitation to join!" |
*
* @param {You_Got_New_InviteInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const you_got_new_invite = /** @type {((inputs?: You_Got_New_InviteInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<You_Got_New_InviteInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_you_got_new_invite(inputs)
	return en_you_got_new_invite(inputs)
});